module.exports = __webpack_public_path__ + "static/media/best_me_7.2a9fb352.jpg";